<div class="validation-rule-set">
  <div style="float:right;">
    <button #addFilter type="button" mat-button class="text-btn" (click)="addRule()" data-testid="vb-add-filter">
      +Add filter
    </button>
    @if (isQueryBuilder) {
      <button type="button" mat-button class="text-btn" (click)="addRuleSet()" data-testid="vb-add-group">
        +Add group
      </button>
    }
    @if (allowRemoveRuleSet && isQueryBuilder) {
      <button type="button" mat-button class="text-btn"
        (click)="requestRemoveRuleSet()" data-testid="vb-clear-group">
        -Clear group
      </button>
    }
  </div>


  @if (!isQueryBuilder && isTopLevel) {
    <button mat-raised-button color="primary" class="rules-button" value="">RULES</button>
  }


  <ul style="list-style:none;margin:4px 0 2px;">
    @for (rule of ruleSet.rules; track rule; let i = $index) {
      <li class="connector">
        @if (isRuleSet(rule)) {
          <validation-rule-set [ruleSet]="rule" [fields]="fields" (removeRuleSetRequest)="removeRuleSet(i)"
          (ruleSetChange)="ruleSetChanged($event, i);" [isQueryBuilder]="false" class="validation-ruleset-item"></validation-rule-set>
        }
        @if (isRule(rule)) {
          <validation-rule [rule]="rule" [fields]="fields" (removeRuleRequest)="removeRule(i)"></validation-rule>
        }
      </li>
    }
  </ul>
</div>
